var _ = "__anchor_preview__";
export {
  _ as t
};

//# sourceMappingURL=imageanchordata-dKT5zAcc.js.map